import axios, { AxiosResponse } from "axios";
import { RatingInformation } from "../dto/RatingInformation";

export interface ReviewView {
  reviewId: number;
  name: string;
  title: string;
  description: string;
  resourceId: number;
  rating: number;
}

export interface CreateReviewRequest extends Omit<ReviewView, "reviewId"> {}

export interface CreateReviewResponse {
  success: boolean;
  approved: boolean;
  blocked: boolean;
}

interface GetReviewsResponse {
  reviews: ReviewView[];
  totalHits: number;
}

export class ReviewService {
  static async createReview(
    reviewData: CreateReviewRequest
  ): Promise<CreateReviewResponse> {
    try {
      const response: AxiosResponse<CreateReviewResponse> = await axios.post(
        "/reviews",
        reviewData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating review:", error);
      throw error;
    }
  }

  static async addRating(
    resourceId: number,
    rating: number
  ): Promise<CreateReviewResponse> {
    try {
      const response: AxiosResponse<CreateReviewResponse> = await axios.post(
        "/reviews",
        {
          resourceId,
          rating,
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error creating review:", error);
      throw error;
    }
  }

  static async getReviews(
    resourceId: number,
    start: number,
    count: number
  ): Promise<GetReviewsResponse> {
    try {
      const response: AxiosResponse<GetReviewsResponse> = await axios.get(
        `/reviews/${resourceId}/${start}/${count}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching reviews:", error);
      throw error;
    }
  }

  static async getRatingInformation(
    resourceId: number
  ): Promise<RatingInformation> {
    try {
      const response: AxiosResponse<RatingInformation> = await axios.get(
        `/reviews/${resourceId}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching reviews:", error);
      throw error;
    }
  }
}
